import ReactDOM from 'react-dom'

type BlockScrollType = {
  open: boolean
  className?: string
}

const BlockScroll = ({ open, className }: BlockScrollType): JSX.Element => (
  <>
    {open &&
      ReactDOM.createPortal(
        <div
          style={{
            position: 'fixed',
            left: 0,
            bottom: 0,
            right: 0,
            top: 0,
          }}
          className={className}
        />,
        document.body,
      )}
  </>
)

export default BlockScroll
